module.exports = __webpack_public_path__ + "media/img/info/events-08ce7456796842d25dc227f3e0dd0506.png";